module.exports = __webpack_public_path__ + "static/img/title_08.574ac08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/title_08.png
// module id = D4Jx
// module chunks = 1